import { SxProps } from '@mui/material';
import {
  successGreenBg,
  surfaceGrey,
  textMuted,
  textPrimary,
  white,
} from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme();

// Pinned to the bottom-left corner of the viewport, above the page content
export const wrapper: SxProps = {
  position: 'fixed',
  left: '16px',
  bottom: '8px',
  zIndex: 1200,
};

export const modal: SxProps = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '12px',
  p: '16px',
  width: '308px',
  bgcolor: surfaceGrey,
  borderRadius: '10px',

  // Fade effect behind the modal that melts the content above into white (Figma)
  '&::before': {
    content: '""',
    position: 'absolute',
    zIndex: -1,
    left: '50%',
    bottom: 0,
    transform: 'translateX(-50%)',
    width: '340px',
    height: '324px',
    background: `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${white} 26.92%)`,
    pointerEvents: 'none',
  },

  // Mobile: spans the full width with a 16px gap on the left and right
  [theme.breakpoints.down('md')]: {
    width: 'calc(100% - 16px)',
    mr: '16px',
    '&::before': {
      width: '100%',
    },
  },
};

export const content: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '12px',
  width: '100%',
};

export const iconWrapper: SxProps = {
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
  borderRadius: '168px',
  bgcolor: successGreenBg,
};

// Icon served by the API, sized to sit inside the round wrapper
export const icon: SxProps = {
  width: '24px',
  height: '24px',
  objectFit: 'contain',
};

export const textBlock: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '4px',
  flexGrow: 1,
};

export const title: SxProps = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  color: textPrimary,
};

export const description: SxProps = {
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: textMuted,
};

export const actionButton: SxProps = {
  alignSelf: 'flex-start',
  minWidth: 'unset',
  p: '8px 16px',
  bgcolor: textPrimary,
  color: white,
  borderRadius: '10px',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  textTransform: 'none',
  boxShadow: 'none',
  marginTop: '8px',
  '&:hover': {
    bgcolor: textPrimary,
    boxShadow: 'none',
  },
};

export const closeButton: SxProps = {
  flex: 'none',
  p: 0,
  width: '24px',
  height: '24px',
};
